import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import widgetTypes from 'platform/site-wide/widgetTypes';

export default store => {
  const root = document.querySelector(
    `[data-widget-type="${widgetTypes.TRAVEL_PAY_CAREGIVER_CONTENT}"]`,
  );
  if (root) {
    import(/* webpackChunkName: "travel-pay-caregiver-content" */ './App').then(
      module => {
        const App = module.default;
        ReactDOM.render(
          <Provider store={store}>
            <App />
          </Provider>,
          root,
        );
      },
    );
  }
};
